import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { rootContainer } from './shadowRoot';
import fetchConfig from './services/config';
import { exposeTAIlor } from './TAIlor';
import { initI18n } from './i18n/i18n';

const root = createRoot(rootContainer);

async function startApp() {
  await fetchConfig();
  await initI18n();
  exposeTAIlor();

  window.TAIlor.handleAimSessionId();

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

startApp();
